import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { getContactDmConfig } from 'src/app/pages/petition/details/shared/api';

import {
	PetitionDetailsPageDecisionMakers,
	type PetitionDetailsPageDecisionMakersQuery,
	type PetitionDetailsPageDecisionMakersQueryVariables,
} from './decisionMakers.graphql';

export type DecisionMakers = NonNullable<
	PetitionDetailsPageDecisionMakersQuery['petition']
>['decisionMakersConnection']['nodes'];

export type DecisionMaker = DecisionMakers[0];

export async function getDecisionMakers(
	petitionSlugOrId: string,
	numDecisionMakers: number,
	utilityContext: UtilityContext,
): Promise<DecisionMakers> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { emailEnabled } = await getContactDmConfig(utilityContext);

	const { data } = await fetch<PetitionDetailsPageDecisionMakersQuery, PetitionDetailsPageDecisionMakersQueryVariables>(
		{
			query: PetitionDetailsPageDecisionMakers,
			variables: {
				slugOrId: petitionSlugOrId,
				numDecisionMakers,
				emailEnabled,
			},
			rejectOnError: false,
		},
	);

	if (!data?.petition?.decisionMakersConnection) throw new Error('Unable to fetch decision makers');

	return data.petition.decisionMakersConnection.nodes;
}
